// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1033":"css/app.6915","8601":"css/admin-app.6915"}[chunkId] + ".css";
};